import { render, staticRenderFns } from "./EnglishArticleInputPanel.vue?vue&type=template&id=62236368&scoped=true"
import script from "./EnglishArticleInputPanel.vue?vue&type=script&lang=js"
export * from "./EnglishArticleInputPanel.vue?vue&type=script&lang=js"
import style0 from "./EnglishArticleInputPanel.vue?vue&type=style&index=0&id=62236368&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62236368",
  null
  
)

export default component.exports